import React from 'react';
import { useClassName } from 'common/hooks';
import './guest-delights.less';
import {
  getContentfulField,
  SVGIcon,
  unwrapContentfulFields,
} from 'common/components';
import { AnimatedText } from '../AnimatedText/AnimatedText';
import { Swiper, SwiperSlide } from 'swiper/react';
import { usePagination } from 'public/screens/Home/Components/usePagination';
import { Pagination } from 'swiper';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import CLPContentBanner from 'public/screens/CustomLandingPage/Components/ContentBanner';

export const GuestDelights = ({ venue }) => {
  const className = useClassName('GuestDelights');
  const tertiaryColor = getContentfulField(venue.parkScreen?.tertiaryColor);
  const testimonials = getContentfulField(venue.parkScreen?.testimonials);
  const pagination = usePagination({});

  const planningBanner =
    venue.parkScreen?.planningBanner &&
    unwrapContentfulFields(venue.parkScreen.planningBanner);

  const slides = (testimonials || []).map((slide) => {
    const body = getContentfulField(slide.fields.body);
    const author = getContentfulField(slide.fields.info);
    const title = getContentfulField(slide.fields.title);
    const stars = getContentfulField(slide.fields.stars);
    const link = getContentfulField(slide.fields.sourceLink);
    const sourceIconFields = getContentfulField(
      slide.fields.sourceIcon
    )?.fields;
    const sourceIcon = sourceIconFields
      ? getContentfulField(sourceIconFields?.file)?.url
      : null;
    const sourceIconAlt = sourceIconFields
      ? getContentfulField(sourceIconFields?.title)
      : null;

    return {
      body,
      author,
      title,
      stars,
      link,
      sourceIcon,
      sourceIconAlt,
    };
  });

  return (
    <div
      className={className('container')}
      style={{ backgroundColor: tertiaryColor }}>
      {Boolean(planningBanner) && (
        <CLPContentBanner component={planningBanner} />
      )}
      <div className={className('header')}>
        <h2 className={className('header__title')}>
          <AnimatedText text="Guest Delights" />
        </h2>
        <p className={className('header__description')}>
          Real stories. Real smiles. Take a peek into the adventures and joyful
          moments shared by our guests.
        </p>
      </div>
      <div className={className('testimonials')}>
        <Swiper
          {...pagination}
          centeredSlides
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 1,
            },
            1128: {
              slidesPerView: 3,
            },
          }}
          spaceBetween={28}
          modules={[Pagination]}
          className={className('testimonials__carousel')}
          onSwiper={(swiper) => {
            const bullets = swiper.pagination.bullets;
            console.info(bullets.length);
          }}
          loop>
          {slides.map((slide, index) => {
            const handleClick = () => {
              if (slide.link) {
                window.open(slide.link, '_blank', 'noopener,noreferrer');
              }
            };

            return (
              <SwiperSlide
                key={index}
                className={className(
                  'testimonials__carousel__slide',
                  slide.link ? 'clickable' : null
                )}
                onClick={handleClick}>
                {typeof slide?.stars !== 'undefined' && (
                  <div
                    className={className(
                      'testimonials__carousel__slide__stars'
                    )}>
                    {new Array(slide.stars).fill(0).map((star, index) => (
                      <SVGIcon key={index} name="golden-star" />
                    ))}
                  </div>
                )}
                <div
                  className={className(
                    'testimonials__carousel__slide__content'
                  )}>
                  <h3
                    className={className(
                      'testimonials__carousel__slide__content__title'
                    )}>
                    {slide.title}
                  </h3>
                  <p
                    className={className(
                      'testimonials__carousel__slide__content__body'
                    )}>
                    {documentToReactComponents(slide.body)}
                  </p>
                </div>
                <p
                  className={className(
                    'testimonials__carousel__slide__author'
                  )}>
                  <span>{slide.author}</span>
                  {slide.sourceIcon && (
                    <img src={slide.sourceIcon} alt={slide.sourceIconAlt} />
                  )}
                </p>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};
